module.exports = __webpack_public_path__ + "assets/img/hl_d_1.e64f5c5c.png";